<template>
    <div class="vue-area-manager-finder container">
        <div class="row">
            <div class="col-lg-4 offset-lg-2 col-md-8 offset-md-2">
                <slot></slot>

                <select v-model="countryCode" class="mt-5">
                    <option v-for="country in countryCodes" :value="country.value">{{ country.text }}</option>
                </select>

                <div class="search-wrapper mt-2" :class="{'loading': loading}">
                    <input v-model="zipCode" @input="handleInput" type="number" min="0" :placeholder="placeholderText">
                    <dentaid-loader v-if="loading"></dentaid-loader>
                </div>
            </div>
            <div class="col-lg-3 offset-lg-1 col-md-6 offset-md-3 mt-5 mt-lg-0">
                <template v-if="hasAreaManager && !noResult">
                    <h4 class="mb-3">{{ areaManagerText }}</h4>

                    <area-manager-teaser
                        :item="areaManager"
                    ></area-manager-teaser>
                </template>

                <area-manager-placeholder
                    v-if="!hasAreaManager || noResult"
                    :placehold-text="getPlaceholderText"
                ></area-manager-placeholder>
            </div>
        </div>
    </div>
</template>

<script>
import AreaManagerTeaser from "./AreaManagerTeaser";
import AreaManagerPlaceholder from "./AreaManagerPlaceholder";

export default {
    name: "AreaManagerFinder",

    components: {
        AreaManagerTeaser,
        AreaManagerPlaceholder
    },

    props: {
        currentLanguage: {
            type: String,
            default: 'nl'
        }
    },

    data() {
        return {
            areaManager: {},
            zipCode: '',
            countryCode: 'dentaid.nl',
            countryCodes: [
              { text: 'Nederland', value: 'dentaid.nl' },
              { text: 'België', value: 'dentaid.be' },
              { text: 'Luxemburg', value: 'dentaid.lu' },
            ],
            noResult: false,
            placeholderText: window.Drupal.t('Search on ZIP code e.g. 0000'),
            areaManagerText: window.Drupal.t('Your Area Manager'),
            noResultText: window.Drupal.t('No results for that zip code, please try another.'),
            loading: false,
        }
    },

    created() {

        this.countryCodes.forEach((country) => {
          if (country.value.includes(window.location.host)) {
            this.countryCode = country.value;
          }
        });

    },

    computed: {
        hasAreaManager() {
            return !_.isEmpty(this.areaManager)
        },

        showPlaceholder() {
            return _.isEmpty(this.zipCode) || !this.hasAreaManager && this.noResult
        },

        getPlaceholderText() {
            if (this.noResult) {
                return this.noResultText
            }

            return window.Drupal.t('First find an Area Manager in your area.')
        }
    },

    methods: {
        handleInput: _.debounce(function () {
            let zipCode = parseFloat(this.zipCode)
            let countryCode = this.countryCode;

            if (!_.isFinite(zipCode)) {
                return
            }

            this.fetchAreaManager(zipCode, countryCode)
        }, 450),

        fetchAreaManager(zipCode, countryCode) {
            this.loading = true

            axios.get(`/api/area-managers?zipCode=${zipCode}&countryCode=${countryCode}`)
                .then(response => {
                    if (_.isEmpty(response.data)) {
                        this.areaManager = {}
                        this.noResult = true
                        return;
                    }

                    this.areaManager = response.data
                    this.noResult = false
                })
                .catch(error => {
                    this.areaManager = {}
                    this.noResult = true
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
